// extracted by mini-css-extract-plugin
export var colorSquare = "_tn-0";
export var danger = "_tn-5";
export var lightPink = "_tn-8";
export var neutralBlue = "_tn-7";
export var neutralYellow = "_tn-6";
export var normal = "_tn-1";
export var primary = "_tn-2";
export var primaryLight = "_tn-3";
export var solidBlack = "_tn-g";
export var solidGreen = "_tn-b";
export var solidLightBlue = "_tn-d";
export var solidNavy = "_tn-c";
export var solidOrange = "_tn-f";
export var solidPink = "_tn-e";
export var solidRed = "_tn-9";
export var solidYellow = "_tn-a";
export var success = "_tn-4";